/*>
* @license
* Copyright (c) 2014-2022 ABILITY Network, Inc., an INOVALON, Inc. company. All Rights Reserved.
* 
* This computer program is CONFIDENTIAL and a TRADE SECRET of ABILITY Network, Inc.
* The receipt or possession of this program does not convey any rights to use,
* reproduce or disclose its contents in whole or in part, without the specific
* written consent of ABILITY Network, Inc. Any use, reproduction or disclosure of
* this program without the express written consent of ABILITY Network, Inc. is a
* violation of the copyright laws and may subject you to criminal prosecution.
<*/
import { observable, action } from 'mobx'
import { injectable } from 'inversify'
import { UserSession } from './UserSession'
import { injectProperty } from '../../configuration/ServiceLocator'
import { IUserSessionStateManager } from './contracts'
import { IUserSessionMiddleware } from '../middleware/UserSessionMiddleware/contracts'

@injectable()
export class UserSessionStateManager implements IUserSessionStateManager {
	@observable
	userSession: UserSession

	@injectProperty('IUserSessionMiddleware')
	userSessionMiddleware!: IUserSessionMiddleware

	constructor () {
		this.userSession = UserSession.getUserSessionNull()
	}

	@action loadSessionJwt(isTimeoutPopup: boolean): Promise<void> {
		return this.userSessionMiddleware
			.loadSessionJwt(isTimeoutPopup)
			.then(sessionJwt => {
				const userSession = UserSession.getUserSessionFromJwt(sessionJwt)
				this.setUserSession(userSession)
			})
			.catch(error => {
				console.error(`error encountered in UserSessionMiddleware: ${JSON.stringify(error)}`)
				this.setUserSession(UserSession.getUserSessionNull())
			})
	}

	@action setUserSession(userSession: UserSession): void {
		this.userSession = userSession
	}

	@action simulateTokenNearExpiration() {
		this.setUserSession(UserSession.getUserSessionNearExpiration())
	}

	@action simulateTokenExpired() {
		this.setUserSession(UserSession.getUserSessionExpired())
	}
}
